import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        console.log('ScrollToTop triggered');
        // Use requestAnimationFrame to ensure DOM has updated
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        });
    }, [pathname]);

    return null;
}

export default ScrollToTop;